/* eslint-disable react/forbid-component-props */
import { Field } from 'formik';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { LINK_ECOMMERCE_TERMS } from '../../../config/links/links';
import { I_AGREE } from '../../../config/text/text';
import ThemeContext from '../../../providers/ThemeProvider';

const PaymentAgreeTerms = ({ disabled }) => {
  const theme = useContext(ThemeContext);
  const site = process.env.NEXT_PUBLIC_SITE;
  const agreeLinkHref = disabled ? null : LINK_ECOMMERCE_TERMS[site]?.href;
  const agreeLinkText = LINK_ECOMMERCE_TERMS[site]?.text;

  return (
    <>
      <p>
        <label className="agree-terms-label" htmlFor="confirmPayment">
          {I_AGREE}{' '}
          <a
            className="agree-terms-link"
            href={agreeLinkHref}
            rel="noreferrer noopener"
            target="_blank"
          >
            {agreeLinkText}
          </a>
        </label>
        <Field
          className="agree-terms-checkbox"
          data-qa="eCommerceTermsCheck"
          disabled={disabled}
          id="confirmPayment"
          name="confirmPayment"
          type="checkbox"
        />
        <style jsx>{`
          .agree-terms-label {
            font-weight: bold;
          }
          .agree-terms-link {
            color: ${theme.colors.primary};
          }
          .agree-terms-link:hover {
            color: ${theme.colors.checkoutlinkhover};
            text-decoration: underline;
          }
          :global(.agree-terms-checkbox) {
            float: right;
          }
        `}</style>
      </p>
    </>
  );
};

PaymentAgreeTerms.propTypes = {
  disabled: PropTypes.bool,
};

export default PaymentAgreeTerms;
